import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { displaySelector } from "../../../features/display/displaySlice";

import { backendApi } from "../../../app/services/backendApi";

import { Grid, ListItem } from "@mui/material";
import styles from "../../../styles/breakingnews.module.css";

const Infobar = () => {
  const display = useSelector(displaySelector);

  const delayDisplayNextLog = 30000; // 30000 for 30 seconds
  const delayGetLogs = 30000;
  const watchPeriod = 1800; // period in seconds : 1800 for 30 minutes, 84600 for 1 day

  const [currentLog, setCurrentLog] = useState(undefined);
  const [scrollingTabText, setScrollingTabText] = useState([]);

  const [nbLogs, setNbLogs] = useState(0);
  const [index, setIndex] = useState(0);

  const [triggerAllBreakingLog, responseAllBreakingLog] =
    backendApi.endpoints.getAllBreakingLog.useLazyQuery();

  /* --------------------------------------------------------------------- */

  /* - update index every 30 secondes - */
  useEffect(() => {
    const id = setInterval(() => {
      setIndex((c) => c + 1);
    }, delayDisplayNextLog);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    triggerAllBreakingLog(watchPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* - get list breaking logs every 30 secondes - */
  useEffect(() => {
    const intervalGetLog = setInterval(() => {
      triggerAllBreakingLog(watchPeriod);
    }, delayGetLogs);
    return () => clearInterval(intervalGetLog);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* --------------------------------------------------------------------- */

  useEffect(() => {
    if (
      responseAllBreakingLog.data !== undefined &&
      responseAllBreakingLog.isSuccess
    ) {
      if (Number.isInteger(responseAllBreakingLog.data.length)) {
        setNbLogs(responseAllBreakingLog.data.length);
      }

      if (currentLog === undefined) {
        setCurrentLog(responseAllBreakingLog.data[0]);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseAllBreakingLog]);

  /* --------------------------------------------------------------------- */
  const buildScrollingTab = (message) => {
    let tab = [];
    tab[0] =
      message.length <= 300 ? message : message.substring(0, 300) + " ...";
    setScrollingTabText(tab);
  };

  /**************************************************************************
   * useEffect when index to select a log is updated
   * ***********************************************************************/
  useEffect(() => {
    if (nbLogs > 0) {
      if (index < nbLogs) {
        setCurrentLog(responseAllBreakingLog.data[index]);
      } else {
        setIndex(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  useEffect(() => {
    if (currentLog !== undefined) {
      buildScrollingTab(currentLog.message);
    }
  }, [currentLog]);

  /* --------------------------------------------------------------------- */
  return (
    <>
      <div
        className={
          display.isDisplaySidebar
            ? styles.breakingnewsReduce
            : styles.breakingnewsFull
        }
      >
        <Grid container spacing={0}>
          <Grid size={2}>
            <ListItem className={styles.headerLog}>
              {nbLogs === 0 && (
                <>
                  <div className={styles.usageIco}>
                    <h1>
                      <span className={styles.fw600}>Aucune erreur</span>
                    </h1>
                    <div className={styles.overlayInfo}></div>
                  </div>
                </>
              )}
              {currentLog?.criticite === "1" && (
                <>
                  <div className={styles.container}>
                    <h1>
                      <span className={styles.fw600}>Info</span>
                      <br />
                      le {currentLog.date}
                    </h1>
                    <div className={styles.overlayInfo}></div>
                  </div>
                  <div className={styles.serviceName}>
                    <h1>
                      <span className={styles.fw800}>{currentLog.surname}</span>
                    </h1>
                  </div>
                </>
              )}
              {currentLog?.criticite === "2" && (
                <>
                  <div className={styles.container}>
                    <h1>
                      <span className={styles.fw600}>Alerte</span>
                      <br />
                      le {currentLog.date}
                    </h1>
                    <div className={styles.overlayWarning}></div>
                  </div>
                  <div className={styles.serviceName}>
                    <h1>
                      <span className={styles.fw800}>{currentLog.surname}</span>
                    </h1>
                  </div>
                </>
              )}
              {currentLog?.criticite >= "3" && (
                <>
                  <div className={styles.container}>
                    <h1>
                      <span className={styles.fw600}>Erreur</span>
                      <br />
                      le {currentLog.date}
                    </h1>
                    <div className={styles.overlayError}></div>
                  </div>
                  <div className={styles.serviceName}>
                    <h1>
                      <span className={styles.fw800}>{currentLog.surname}</span>
                    </h1>
                  </div>
                </>
              )}
            </ListItem>
          </Grid>
          <Grid size={10}>
            <ListItem className={styles.details}>
              <div className={styles.scrollingText}>
                {nbLogs > 0 ? (
                  scrollingTabText.map((partLog, index) => (
                    <div className={styles.dataLog} key={index}>
                      <span>{partLog}</span>
                    </div>
                  ))
                ) : (
                  <div className={styles.dataLog}>
                    <span>
                      {" "}
                      L'ensemble des services s’exécutent correctement.{" "}
                    </span>
                  </div>
                )}
              </div>
            </ListItem>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Infobar;
